import { AdaptiveModal, Box, Button, Checkbox, Icon, Typography } from "@luce/ui";

import { useDeleteAccountContext } from "../delete-account-context";

export function ConfirmDeleteModal() {
  const { step, agreed, isDeleting, setAgreed, confirmDeletion, close } = useDeleteAccountContext();

  const handleOpenChange = (next: boolean) => {
    if (!next) close();
  };

  return (
    <AdaptiveModal.Root open={step === "confirm"} onOpenChange={handleOpenChange} dialogSize="sm">
      <AdaptiveModal.Header align="center">
        <Icon name="Warning" size={28} className="text-luce-system-danger-default" />
        <AdaptiveModal.Title>Confirm Account Deletion</AdaptiveModal.Title>
      </AdaptiveModal.Header>

      <AdaptiveModal.Body>
        <Box className="gap-spacing-lg flex flex-col">
          <Typography variant="body-md">
            Under Section <Typography variant="label-md">46(2)(b)</Typography> of the Singapore
            Goods and Service Tax Act, we have to keep full data of our customers, services, and
            billing for 5 years.
          </Typography>
          <Typography variant="body-md">
            We will mark the account for deletion and the information can only be fully purged from
            our system after 5 years.
          </Typography>
          <Box className="gap-spacing-sm flex flex-row items-center">
            <Checkbox
              checked={agreed}
              onCheckedChange={setAgreed}
              accessibilityLabel="By ticking, you are confirming that you have read, understood, and agree"
            />
            <Typography variant="body-sm" className="flex-1">
              By ticking, you are confirming that you have read, understood, and agree
            </Typography>
          </Box>
        </Box>
      </AdaptiveModal.Body>

      <AdaptiveModal.Footer layout="row">
        <Box className="flex-1">
          <Button
            variant="destructive-secondary"
            size="lg"
            fullWidth
            label="Delete Account"
            loading={isDeleting}
            onClick={confirmDeletion}
          />
        </Box>
        <Box className="flex-1">
          <Button size="lg" fullWidth label="Cancel" onClick={close} />
        </Box>
      </AdaptiveModal.Footer>
    </AdaptiveModal.Root>
  );
}
